var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 48,
    viewBox: "0 0 97 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_119_4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H97V48H0V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H97V48H0V10Z",
    fill: "#F7EC1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-6 10C-6 1.16344 1.16344 -6 10 -6H101L93 6H10C7.79086 6 6 7.79086 6 10H-6ZM101 52H-6L6 44H93L101 52ZM-6 52V10C-6 1.16344 1.16344 -6 10 -6V6C7.79086 6 6 7.79086 6 10V44L-6 52ZM101 -6V52L93 44V6L101 -6Z",
    fill: "black",
    mask: "url(#path-1-inside-1_119_4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 18.4706H67.5V17.4706V8.40631L91.2686 24.8272L67.5 42.0411V33.1933V32.1933H66.5H15V18.4706L66.5 18.4706Z",
    fill: "#52B12F",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.0aeb14f4045eb920671bebad7a7159c1.svg";
export { ForwardRef as ReactComponent };